module.exports = __webpack_public_path__ + "static/media/Engbanner.a748d4f7.png";